// extracted by mini-css-extract-plugin
export default {"userTile":"style_userTile__zhYI3","userInfo":"style_userInfo__qp7fN"};